/**
 * NetworkConfig
 *
 * @deprecated Use `src/shared/config/network.config.ts` directly
 * (`import { NETWORK } from '<path>/shared/config/network.config'`).
 *
 * Backwards-compat shim re-exporting `NETWORK_CONFIG` (legacy name) from
 * the new typed `NETWORK`. Migrate per-file at your leisure. See
 * `docs/plans/2026-04-25-CONFIG-MIGRATION.md`.
 */

import { NETWORK } from '../config/network.config';

export const NETWORK_CONFIG = {
  connectionTimeout: NETWORK.connectionTimeoutMs,
  interpolation: NETWORK.interpolation,
} as const;
